function getAllPosts() {
	return new Promise((resolve, reject) => {
		let postsArr = [];
		function recursiveAPICall(apiURL) {
			FB.api(apiURL, response => {
				if (response && response.data) {
					postsArr = postsArr.concat(response.data);
					if (response.paging && response.paging.next) {
						recursiveAPICall(response.paging.next);
					} else {
						resolve(postsArr);
					}
				} else {
					reject();
				}
			})
		}
		recursiveAPICall('/me/posts?fields=created_time&limit=100');
	});
}

export default new Promise((resolve) => {
  window.fbAsyncInit = function() {
	FB.init({
	  appId	  : '1164461203680010',
	  xfbml	  : true,
	  version	: 'v2.9'
	});
	FB.AppEvents.logPageView();
	$(document).ready(() => {
		$("#authorize").click(() => {
			console.log("clicked");
			FB.login(function(response) {
				if (response.authResponse) {
					$("#authorize").hide();
					$("#loading").show();
					getAllPosts().then(response => {
						resolve(response);
					}).catch(e => {
						console.log(e);
					});
				}
			}, {scope: 'user_posts'});
		});
	});
  };
});


// WEBPACK FOOTER //
// ./fb.js